
import './App.css';
import ProPhoneInput from 'pro-phone-input-library';
const newCountry = {
  name: 'Imaginary Land', 
  nativeName: 'Fantasía', 
  isoCode: ',L', 
  dialCode: '+99', 
  regex: '^\\d{3}$', // Requires exactly 3 digits
  nsnLength: 3 
};
function App() {

  const handleSubmit = (e) => {
    
   console.log('Form submitted!');
  }
     
       return (
    <div className="App" style={{width:"50%",display:"flex",margin:"auto",flexDirection:"column",justifyContent:"center",alignItems:"center"}}>
       
      <header className="text-center pb-4 border-b">
          <h1 className="text-3xl font-bold text-blue-600 flex items-center justify-center">
            <div className="w-7 h-7 mr-2"> Phone Input Demo</div>
          </h1>
          <p className="text-gray-500 text-sm mt-1">
            Demonstrates imperative validation using a React ref.
          </p>
        </header>

        {/* The Form with the ProPhoneInput Component */}
        <form onSubmit={handleSubmit} className="space-y-6">
         
            <ProPhoneInput
       initialValue="5551234567"
     
      defaultCountryCode="US"
      //  Exclude Japan and Germany
      excludeCountries={['JP', 'DE']}
      //  Add the custom country
      addCountries={[newCountry]} 
      //  Use a custom error message
        customErrorMessage="The number must match the national format!" 
        // Disable native names in the dropdown
        disableNativeName={true} 
        onChange={(fullNumber, country, isValid) => {
          console.log(`Full Number: ${fullNumber}, Valid: ${isValid}, Country: ${country.name}`);
        }}></ProPhoneInput>
          <button 
            type="submit" 
            className="w-full bg-blue-600 text-white py-3 rounded-lg font-semibold shadow-lg hover:bg-blue-700 transition duration-150 transform hover:scale-[1.01]"
          >
            Validate & Submit Form
          </button>
        </form>
      
    </div>
  );
}

export default App;

